import { useMemo } from 'react';
import { LifeCover } from '@app/domain/model/eshop/life/LifeCover';
import { Coverage } from '@app/domain/model/Coverage';
import { SelectedCover } from '@app/domain/model/eshop/life/SelectedCover';
import { getAvailableATDOptions } from '@app/app/esales/life/_sections/steps/CustomCoverSelectionStep/getATDBasedMinimums';

const CHOICE_BUTTON_MAX_OPTIONS = 3;
const RANGE_SLIDER_STEP = 1000;

export function useCoverConfigs(covers: LifeCover[], selectedCovers: SelectedCover[]) {
    return useMemo(() => {
        const diCover = selectedCovers.find(sc => sc.code === Coverage.LifeInsurance);
        const apdCover = selectedCovers.find(sc => sc.code === Coverage.DisabilityByAccident);
        const diValue = diCover?.value ?? 0;
        const apdValue = apdCover?.value ?? 0;

        return covers.map(cover => {
            const selectedCover = selectedCovers.find(selectedCover => selectedCover.code === cover.code);

            const hasOptions = cover.options && cover.options.length > 0;
            const canUseChoiceButtons =
                hasOptions && cover.options.length >= 1 && cover.options.length <= CHOICE_BUTTON_MAX_OPTIONS;

            let disabledOptions: number[] = [];
            if (cover.code === Coverage.TemporaryDisabilityByAccident && hasOptions) {
                const atdOptionsResult = getAvailableATDOptions(diValue, apdValue, cover.options);
                disabledOptions = atdOptionsResult.disabledOptions;
            }

            const min = cover.min;
            const max = cover.max;
            const step = RANGE_SLIDER_STEP;

            const isLifeInsurance = cover.code === Coverage.LifeInsurance;

            return {
                cover,
                selectedCover,
                min,
                max,
                step,
                isSwitchDisabled: isLifeInsurance,
                canUseChoiceButtons,
                options: canUseChoiceButtons ? cover.options : [],
                disabledOptions,
            };
        });
    }, [covers, selectedCovers]);
}
